import classNames from 'classnames';
import styles from './styles/styles.module.scss';

type Props = {
  variant: 'leaves';
  className?: string;
  imageSize?: 'full' | 'cropped';
};

const baseImgUrl = 'https://cdn-assets.alltrails.com/assets/images/textures';

export default function Texture({ className, variant, imageSize = 'full' }: Props) {
  const textureSrc = `${baseImgUrl}/${variant}/${imageSize}`;

  return (
    <div className={classNames(styles.container, styles[imageSize], className)}>
      <picture>
        <source srcSet={`${textureSrc}.avif`} type="image/avif" />
        <source srcSet={`${textureSrc}.webp`} type="image/webp" />
        <img className={styles.image} src={`${textureSrc}.jpg`} loading="eager" alt="" />
      </picture>
    </div>
  );
}
